function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Component, register } from 'ovee.js';
import gsap from 'gsap';

var _class = (_dec = register('hero-animation'), _dec(_class2 = /*#__PURE__*/function (_Component) {
  _inherits(_class2, _Component);

  var _super = _createSuper(_class2);

  function _class2() {
    _classCallCheck(this, _class2);

    return _super.apply(this, arguments);
  }

  _createClass(_class2, [{
    key: "init",
    value: function init() {
      this.buonasera = this.$element.querySelector('#Buonasera');
      this.buongiorno = this.$element.querySelector('#Buon_giorno');
      this.buongiornoBcg = this.$element.querySelector('#Rectangle_78');
      this.sun = this.$element.querySelector('#Group_59');
      this.moon = this.$element.querySelector('#Group_69');
      this.moonBcg = this.$element.querySelector('#Rectangle_92');
      this.questionMark = this.$element.querySelector('#_');
      this.exclamation = this.$element.querySelector('#_2');
      this.exclamationBcg = this.$element.querySelector('#Rectangle_97');
      this.pardon = this.$element.querySelector('#Pardon');
      this.voila = this.$element.querySelector('#Voilà');
      this.world = this.$element.querySelector('#Group_62');
      this.worldFrame = this.$element.querySelector('#Rectangle_68');
      this.da = this.$element.querySelector('#да');
      this.daBcg = this.$element.querySelector('#Rectangle_108');
      this.pin = this.$element.querySelector('#Group_71');
      this.water = this.$element.querySelector('#Group_72');
      this.eye = this.$element.querySelector('#Group_73');
      this.mare = this.$element.querySelector('#Mare');
      this.mirar = this.$element.querySelector('#Mirar');
      this.sign = this.$element.querySelector('#Group_67');
      this.signBcg = this.$element.querySelector('#Rectangle_98');
      this.sign2 = this.$element.querySelector('#ю');
      this.sign2Frame = this.$element.querySelector('#Rectangle_100');
      this.animation = this.animation.bind(this);
      this.animation();
    }
  }, {
    key: "animation",
    value: function animation() {
      var tl = gsap.timeline({
        delay: 1.5,
        repeat: -1,
        yoyo: true,
        repeatDelay: 1.5
      });
      tl.to(this.pin, {
        duration: 1.5,
        y: 200,
        ease: 'Quad.easeInOut'
      }, 'start+=.05').to(this.daBcg, {
        duration: 1.5,
        y: 0,
        ease: 'Quad.easeInOut'
      }, 'start-=.01').to(this.da, {
        duration: 1.5,
        y: 83,
        ease: 'Quad.easeInOut'
      }, 'start-=.06').to(this.worldFrame, {
        duration: 1.5,
        x: 2,
        ease: 'Quad.easeInOut'
      }, '<').to(this.world, {
        duration: 1.5,
        x: 70,
        ease: 'Quad.easeInOut'
      }, '<').to(this.buongiornoBcg, {
        duration: 1.5,
        y: 180,
        ease: 'Quad.easeInOut'
      }, '>').to(this.buongiorno, {
        duration: 1.5,
        y: 200,
        ease: 'Quad.easeInOut'
      }, '<').to(this.buonasera, {
        duration: 1.5,
        y: 85,
        ease: 'Quad.easeInOut'
      }, '<').to(this.sun, {
        duration: 1.5,
        x: -100,
        ease: 'Quad.easeInOut'
      }, '<').to(this.moon, {
        duration: 1.5,
        x: 45,
        ease: 'Quad.easeInOut'
      }, '<').to(this.moonBcg, {
        duration: 1.5,
        x: 0,
        ease: 'Quad.easeInOut'
      }, '<').to(this.questionMark, {
        duration: 1.5,
        x: 170,
        ease: 'Quad.easeInOut'
      }, '>').to(this.exclamation, {
        duration: 1.5,
        x: 75,
        ease: 'Quad.easeInOut'
      }, '<').to(this.exclamationBcg, {
        duration: 1.5,
        x: 0,
        ease: 'Quad.easeInOut'
      }, '<').to(this.pardon, {
        duration: 1.5,
        y: -100,
        ease: 'Quad.easeInOut'
      }, '<').to(this.voila, {
        duration: 1.5,
        y: 83,
        ease: 'Quad.easeInOut'
      }, '<').to(this.sign2, {
        duration: 1.5,
        x: 69,
        ease: 'Quad.easeInOut'
      }, '<').to(this.sign2Frame, {
        duration: 1.5,
        x: 2,
        ease: 'Quad.easeInOut'
      }, '<').to(this.mare, {
        duration: 1.5,
        y: -20,
        ease: 'Quad.easeInOut'
      }, '>').to(this.mirar, {
        duration: 1.7,
        y: 81,
        ease: 'Quad.easeInOut'
      }, '<').to(this.water, {
        duration: 1.5,
        x: -200,
        ease: 'Quad.easeInOut'
      }, '>').to(this.eye, {
        duration: 1.5,
        x: 76,
        ease: 'Quad.easeInOut'
      }, '<');
    }
  }]);

  return _class2;
}(Component)) || _class2);

export { _class as default };